<template>
  <div
    class="sitebuilder-element-container"
    element="VidelloVideoComponent"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :id="id"
    :style="style()"
  >
      <!-- <rotate :target="this.$refs.draggableResizable" :config="this.internal_config" />
      <sync-drag :target="this" /> -->
      <!-- <options-element-bar ref="optionsBar" :elem="this" name="ct-component-VidelloComponent">
            <img  src="static/images/icons/pin.svg"
              v-tooltip="{content:$t('ct-sticky'),  class: 'tooltip-custom'}"
              class="svg-icon normal-action hide-resource-on-mobile"
              @click="StickyElement"/>
      </options-element-bar> -->
      <div id="the-sticky-div" class="embed-responsive embed-responsive-16by9">
         <div class="sticky-video-content">
          <div class="video">
            <iframe
              :width="internal_config.width"
              :height="internal_config.height"
              :src="internal_config.src"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="embed-responsive-item"
              v-bind:style="{'border-radius': radius,border : border}"
            ></iframe>
          </div>
         </div>
      </div>
  </div>
</template>
<script>
import Model from "./Model";
// import Resources from "./Resources.vue";
// import OptionsElementBar from "../OptionsElementBar";

export default {
  name: "VidelloVideoComponent",
  components: {
    // OptionsElementBar,
    Model,
   // Resources
  },
  props: ["config", "height_start", "device", "id", "preview"],
  data() {
    return Model.data();
  },
  computed: {
    width() {
      return this.internal_config.width;
    },
    height() {
      return this.internal_config.height;
    },
    border() {
      return this.internal_config.border;
    },
    radius() {
      return this.internal_config.borderRadius;
    }
  },
  // watch: {
  //   internal_config: {
  //     deep: true,
  //     handler(value) {
  //       this.$eventHub.setValueElementConfig(this.id, value);
  //     }
  //   }
  // },

  methods: {
    animation() {
      return true;
    },
    //change order on html
    style() {
      let style = `left:  ${this.internal_config.left};
                    width: ${this.internal_config.width};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
      return style;
    },
    updated(){
      if( this.device == "desktop"){
      if(this.preview){
        if (this.internal_config.StickyVideo) {
          this.$root.$emit("applySticky", this,);
      }
    }
      }
   },
  },
  created() {
    let device, childs, id, config;
    ({ device, childs, id, config } = this.$props);
    this.internal_config = config;
    this.device = device;
    if (typeof id !== "undefined") {
      this.id = id;
    }
    this.internal_config = window.mergeRecursive(
      this.props,
      this.$props.config
    );
  },
  mounted() {
      if( this.device == "desktop"){
        if (this.internal_config.StickyVideo) {
            this.$root.$emit("applySticky", this,);
        }
      }

      this.$root.$emit("applyAnimation", this, "sitebuilder-element-container");

    let objIds = [];
    $("[id]").each(function() {
      var ids = $('[id="' + this.id + '"]');
      if (ids.length > 1 && ids[0] == this && parseInt(this.id))
        objIds.push(this.id);
    });
    if (objIds.includes(this.id)) {
      this.id = Date.now() + parseInt(Math.random() * 10000);
    }

    this.$root.$on("setConfigElement", (id, obj) => {
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$forceUpdate();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vdr {
  height: auto !important;
}
iframe{
  overflow: hidden;
}

#the-sticky-div {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden;
  } 

  /*Small*/
  .stuckBRs, .stuck-bottom-right-small {
    position: fixed;
    transform: translateY(100%);
    width: 260px !important;
    height: 145px !important;
    animation: fade-in-up .25s ease forwards;

    right: 25px;
    left: unset !important;
    top: unset !important;
    bottom: 10px;
    z-index: 100 !important;
  }

  .stuckTLs, .stuck-top-left-small {
    position: fixed;
    transform: translateY(100%);
    width: 260px !important;
    height: 145px !important;
    animation: fade-in-up .25s ease forwards;

    left: 10px !important;
    top: 10px !important;
    z-index: 100 !important;
  }

  .stuckTRs, .stuck-top-right {
    position: fixed;
    transform: translateY(100%);
    width: 260px !important;
    height: 145px !important;
    animation: fade-in-up .25s ease forwards;

    right: 25px;
    left: unset !important;
    top: 10px !important;
    z-index: 100 !important;
  }

  .stuckBLs, .stuck-bottom-left {
    position: fixed;
    transform: translateY(100%);
    width: 260px !important; 
    height: 145px !important;
    animation: fade-in-up .25s ease forwards;

    right: unset;
    left: 10px !important;
    top: unset !important;
    bottom: 10px;
    z-index: 100 !important;
  } 
  /*Medium*/
  .stuckBRm, .stuck-bottom-right-medium {
    position: fixed;
    transform: translateY(100%);
    width: 400px !important;
    height: 227px !important;
    animation: fade-in-up .25s ease forwards;

    right: 25px;
    left: unset !important;
    top: unset !important;
    bottom: 10px;
    z-index: 100 !important;
  }

  .stuckTLm, .stuck-top-left-medium {
    position: fixed;
    transform: translateY(100%);
    width: 400px !important;
    height: 227px !important;
    animation: fade-in-up .25s ease forwards;

    left: 10px !important;
    top: 10px !important;
    z-index: 100 !important;
  }

  .stuckTRm, .stuck-top-right-medium {
    position: fixed;
    transform: translateY(100%);
    width: 400px !important;
    height: 227px !important;
    animation: fade-in-up .25s ease forwards;

    right: 25px;
    left: unset !important;
    top: 10px !important;
    z-index: 100 !important;
  }

  .stuckBLm, .stuck-bottom-left {
    position: fixed;
    transform: translateY(100%);
    width: 400px !important;
    height: 227px !important;
    animation: fade-in-up .25s ease forwards;

    right: unset;
    left: 10px !important;
    top: unset !important;
    bottom: 10px;
    z-index: 100 !important;
  } 
  /*Large*/
  .stuckBRl, .stuck-bottom-right {
    position: fixed;
    transform: translateY(100%);
    width: 500px !important;
    height: 283px !important;
    animation: fade-in-up .25s ease forwards;

    right: 25px;
    left: unset !important;
    top: unset !important;
    bottom: 10px;
    z-index: 100 !important;
  }

  .stuckTLl, .stuck-top-left {
    position: fixed;
    transform: translateY(100%);
    width: 500px !important;
    height: 283px !important;
    animation: fade-in-up .25s ease forwards;

    left: 10px !important;
    top: 10px !important;
    z-index: 100 !important;
  }

  .stuckTRl, .stuck-top-right {
    position: fixed;
    transform: translateY(100%);
    width: 500px !important;
    height: 283px !important;
    animation: fade-in-up .25s ease forwards;

    right: 25px;
    left: unset !important;
    top: 10px !important;
    z-index: 100 !important;
  }

  .stuckBLl, .stuck-bottom-left {
    position: fixed;
    transform: translateY(100%);
    width: 500px !important;
    height: 283px !important;
    animation: fade-in-up .25s ease forwards;

    right: unset;
    left: 10px !important;
    top: unset !important;
    bottom: 10px;
    z-index: 100 !important;
  } 
</style>
</style>
